module.exports = __webpack_public_path__ + "img/presenter_watanabe@2x.53272fd3.jpg";